<template>
    <tr>
        <td>
            {{ contact.name }}
        </td>
        <td>
            {{ contact.type }}
        </td>
        <td>
            {{ contact.contact }}
        </td>
        <td class="text-end">
            <div class="me-4">
                <a data-bs-toggle="dropdown" href="#" class="btn p-1" aria-expanded="false">
                    <font-awesome-icon :icon="['fas', 'bars']"/>
                </a>
                <div class="dropdown-menu dropdown-menu-end" style="">
                    <a role="button" v-on:click="this.delete()" class="dropdown-item">Supprimer</a>
                </div>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
    props: ['contact'],
    methods: {
        delete() {
            this.$emit("delete", this.contact.id);
        }
    }
}
</script>